import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API } from "../context/AppContext";
import ProductCard from "../components/ProductCard";

export default function Shop({ accessories = false }) {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("All");
  const [q, setQ] = useState("");

  useEffect(() => { axios.get(`${API}/products`).then(r => setProducts(r.data)); }, []);
  useEffect(() => { setCat("All"); setQ(""); }, [accessories]);

  // /shop = peptides + reconstitution consumables; /accessories = hardware only.
  const pool = useMemo(() => products.filter(p => accessories ? p.kind === "accessory" : p.kind !== "accessory"), [products, accessories]);
  const cats = useMemo(() => ["All", ...Array.from(new Set(pool.map(p => p.category)))], [pool]);
  const filtered = useMemo(() =>
    pool.filter(p =>
      (cat === "All" || p.category === cat) &&
      (q === "" || p.name.toLowerCase().includes(q.toLowerCase()) || p.tagline?.toLowerCase().includes(q.toLowerCase()))
    ),
  [pool, cat, q]);

  return (
    <div className="bg-black min-h-screen">
      <div className="pt-32 pb-16 px-6 lg:px-10 max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <div className="bl-eyebrow">/ {accessories ? "Lab Hardware" : "Collection"}</div>
            <h1 className="bl-heading text-5xl md:text-6xl text-white mt-4" data-testid="shop-title">{accessories ? "Accessories" : "Shop"}</h1>
            {accessories && <p className="text-white/55 text-sm mt-4 max-w-xl">Cold-chain storage and handling equipment for the research bench. Sold as laboratory accessories only.</p>}
          </div>
          <input
            data-testid="shop-search"
            value={q} onChange={e => setQ(e.target.value)}
            placeholder={accessories ? "Search accessories..." : "Search compound..."}
            className="w-full md:w-80 bg-transparent border border-white/10 focus:border-[color:var(--bl-blue)] outline-none px-4 py-3 font-mono text-sm text-white placeholder:text-white/30"
          />
        </div>
        <div className="flex flex-wrap gap-2 mb-12 border-y border-white/5 py-4 -mx-2 px-2">
          {cats.map(c => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`}
              onClick={() => setCat(c)}
              className={`font-mono text-[11px] tracking-[0.25em] uppercase px-4 py-2 border transition-colors ${
                cat === c ? "border-[color:var(--bl-blue)] text-[color:var(--bl-blue)]" : "border-white/10 text-white/60 hover:text-white"
              }`}
            >{c}</button>
          ))}
        </div>

        <div data-testid="shop-grid" className="grid gap-10 md:gap-y-16 md:grid-cols-2 lg:grid-cols-3">
          {filtered.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
        {filtered.length === 0 && (
          <div className="text-center py-20 text-white/40 font-mono tracking-[0.25em] uppercase">No results</div>
        )}
      </div>
    </div>
  );
}
